import { ChangeDetectorRef, HostBinding } from "@angular/core"
import { Input } from "@angular/core"
import { FormControl } from "@angular/forms"
import { ScrollService } from "./step/scroll.service"

function valueNotFalsy(value: any): boolean {
  return value !== undefined && value !== null && value !== ''
}

export interface FormComponent {
  position: 'left' | 'right' | 'fullwidth',
  path: string,
  label: string,
  placeholder: string,
  disabled: boolean,
  required: boolean
}

export abstract class Abstract_Form_Component implements FormComponent {
  @Input()@HostBinding('class') position!: "left" | "right" | "fullwidth"
  @Input() path!: string
  @Input() label!: string
  @Input() placeholder!: string
  @Input() disabled!: boolean
  @Input() required!: boolean
  error!: string | null
  labelState!: 'displayLabel' | 'hideLabel'
  touchedOrDirty!: boolean
  touchedOrDirtyAndInvalid!: boolean
  controlValueIsNotFalsy!: boolean
  @Input() formControl!: FormControl
  protected focused: boolean = false
  abstract updateLabelState(): void
  protected updateControlValueFalsy() {
    this.controlValueIsNotFalsy = valueNotFalsy(this.formControl.value)
  }

  constructor(protected readonly cd: ChangeDetectorRef, protected readonly scroll: ScrollService ) { }
}